import { Component } from '@angular/core';
import { LDWDocument } from '../../shared/models/LDWDocument';

@Component({
    selector: 'ldw-manual-page',
    templateUrl: './manual-page.component.html',
    styleUrls: ['./manual-page.component.css'],
    standalone: false
})
export class ManualPageComponent {
  get document(): LDWDocument {
    const doc = new LDWDocument();
    doc.id = '$$MANUAL$$';
    return doc;
  }
}
